import React, { useMemo } from "react";
import { Trash2 } from "lucide-react";
import Table from "../../../../components/Table";
import Pagination from "../../../../components/Pagination";
import { useHistoricoProducao } from "../context/HistoricoProducaoContext";
import type { TableAction } from "../../../../utils/tableActions";

const HistoricoProducaoTable: React.FC = () => {
  const {
    producoes,
    isLoading,
    formatDate,
    formatTime,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    setCurrentPage,
    handleDelete,
    isAdministrator,
  } = useHistoricoProducao();

  const tableData = producoes.map((producao) => [
    formatDate(producao.dataInicio),
    formatDate(producao.dataFim),
    producao.loja?.nome || "-",
    producao.usuario?.nome || "-",
    producao.borda?.nome || "-",
    producao.tamanho?.nome || "-",
    formatTime(producao.tempoTotal),
    formatDate(producao.createdAt),
  ]);

  const tableActions: TableAction[] | undefined = useMemo(() => {
    if (!isAdministrator) return undefined;
    return [
      {
        icon: <Trash2 size={16} />,
        onClick: handleDelete,
        className: "text-red-600 hover:text-red-900",
      },
    ];
  }, [isAdministrator, handleDelete]);

  if (isLoading) {
    return (
      <div className="rounded-lg bg-white p-6 shadow">
        <div className="text-center text-neutral-500">Carregando...</div>
      </div>
    );
  }

  return (
    <>
      <Table
        headers={[
          "Data Início",
          "Data Fim",
          "Loja",
          "Usuário",
          "Borda",
          "Tamanho",
          "Tempo Total",
          "Data Criação",
        ]}
        data={tableData}
        actions={tableActions}
        actionsColumnTitle="Opções"
      />
      {totalPages > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
        />
      )}
    </>
  );
};

export default HistoricoProducaoTable;
